import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataTaktile } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '../../playbook-builder.types';
import BaseNode from '../base-node';
import DrawerContent from './drawer-content';
export const TaktileNode = node => {
  const $ = _c(6);
  let t0;
  if ($[0] !== node) {
    t0 = {
      size: "lg",
      form: "taktile-form",
      render: () => <DrawerContent node={node} />
    };
    $[0] = node;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== node.data || $[3] !== node.id || $[4] !== t0) {
    t1 = <BaseNode nodeId={node.id} data={node.data} sidebar={t0} />;
    $[2] = node.data;
    $[3] = node.id;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};